module.exports = __webpack_public_path__ + "static/media/32.88bb030a.png";